<template>
  <div class="category-content">
    <div class="main-width">
      <!-- <div class="category-breadcrumb">
        @click="closeBread(0)"
        <a class="category-breadcrumb-default">全部商品:</a>
        <span class="category-breadcrumb-level-wrap category-haschild" v-for="(item, index) in breadcrum"
          @click="closeBread(item.deep)">
          <a class="category-breadcrumb-level">{{ item.name }}</a>
        </span>
      </div> -->
      <div v-show="true" class="category-select">
        <div v-show="false" class="category-select-block" :class="{ 'display-none': conditionShow.one }">
          <div class="category-select-block-name">一级分类:</div>
          <ul :class="{ more: more.one }">
            <li @click="setcate(item.id, item.deep, item.name)" v-for="item in categoryOneData"
              :class="{ select_category: item.isSelect }">
              {{ item.name }}
            </li>
          </ul>
          <span class="category-select-more category-select-btn" :class="{ 'display-none': more.one }"
            @click="open(1)">更多</span>
          <span class="category-select-less category-select-btn" :class="{ 'display-none': !more.one }"
            @click="open(1)">收起</span>
        </div>
        <div class="category-select-block" :class="{ 'display-none': conditionShow.two }">
          <div class="category-select-block-name">二级分类:</div>
          <ul :class="{ more: more.two }">
            <li @click="setcate(item.id, item.deep, item.name)" v-for="item in categoryTwoData"
              :class="{ select_category: item.isSelect }">
              {{ item.name }}
            </li>
          </ul>
          <span class="category-select-more category-select-btn" :class="{ 'display-none': more.two }"
            @click="open(2)">更多</span>
          <span class="category-select-less category-select-btn" :class="{ 'display-none': !more.two }"
            @click="open(2)">收起</span>
        </div>
        <div v-show="false" class="category-select-block category-select-brand"
          :class="{ 'display-none': conditionShow.three }">
          <div class="category-select-block-name">品牌:</div>
          <span class="category-select-more category-select-btn" :class="{ 'display-none': more.three }"
            @click="open(3)">更多</span>
          <span class="category-select-less category-select-btn" :class="{ 'display-none': !more.three }"
            @click="open(3)">收起</span>
          <ul :class="{ more: more.three }">
            <li v-for="item in brandData" :class="{ select_category_brand: item.isSelect }"
              @click="setBracdSelect(item.id)">
              <img :src="imgAddress + item.logoPath" @error="error(3)" />
            </li>
          </ul>
        </div>
        <div class="category-select-block" v-bind:class="{
          'display-none': conditionShow.four || !categoryThreeData.length,
        }">
          <div class="category-select-block-name">三级分类:</div>
          <ul :class="{ more: more.four }">
            <li @click="setcate(item.id, item.deep, item.name)" v-for="item in categoryThreeData"
              :class="{ select_category: item.isSelect }">
              {{ item.name }}
            </li>
          </ul>
          <span class="category-select-more category-select-btn" :class="{ 'display-none': more.four }"
            @click="open(4)">更多</span>
          <span class="category-select-less category-select-btn" :class="{ 'display-none': !more.four }"
            @click="open(4)">收起</span>
        </div>

        <div class="category-select-block border-bottom-none" style="height: 33px; max-height: initial">
          <div class="category-select-block-name">条件筛选：</div>
          <ul style="height: 75px; max-height: 75px">
            <li>
              <span class="category-filter-condition-item section" style="width: 210px">
                <a>毛利</a>
                <div class="section-wrap">
                  <div>
                    <input type="text" v-model="commissionSectionMin" />
                  </div>
                  <div class="line">——</div>
                  <div>
                    <input type="text" v-model="commissionSectionMax" />
                  </div>
                </div>
              </span>
            </li>
            <li>
              <span class="category-filter-condition-item section">
                <a>结算价</a>
                <div class="section-wrap">
                  <div>
                    <input type="text" v-model="priceSectionMin" />
                  </div>
                  <div class="line">——</div>
                  <div>
                    <input type="text" v-model="priceSectionMax" />
                  </div>
                </div>
              </span>
            </li>
            <li>
              <span class="category-filter-condition-item section" style="width: 250px">
                <a>建议零售价</a>
                <div class="section-wrap">
                  <div>
                    <input type="text" v-model="salePriceMin" />
                  </div>
                  <div class="line">——</div>
                  <div>
                    <input type="text" v-model="salePriceMax" />
                  </div>
                </div>
              </span>
            </li>
            <li>
              <span class="category-filter-condition-item section">
                <a>毛利率</a>
                <div class="section-wrap">
                  <div>
                    <input type="text" v-model="profitSectionMin" />
                  </div>
                  <div class="line">——</div>
                  <div>
                    <input type="text" v-model="profitSectionMax" />
                  </div>
                </div>
              </span>
            </li>
            <li style="padding-top: 8px; position: absolute; right: 0">
              <el-button class="section-init" :style="{ 'border-color': colorMain, background: colorMain }"
                @click="sectionInit">确定</el-button>
              <el-button class="section-init" :style="{
                'border-color': colorMain,
                background: 'white',
                color: colorMain,
              }" @click="onCancel">重置</el-button>
            </li>
            <!-- <li style="width: 236px">
              <a style="line-height: 2.3">上架时间</a>
              <div class="section-wrap">
                <span class="delete-time">
                  <el-date-picker v-model="upTime" type="datetimerange" size="mini"
                    :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期"
                    end-placeholder="结束日期"></el-date-picker>
                </span>
              </div>
            </li> -->
          </ul>
        </div>
      </div>

      <div class="category-filter-condition">
        <span v-show="false" class="category-filter-condition-item" @click="setOrderRule(1)" :class="{
          'category-filter-condition-select': condition.priceSectionSort == 1,
        }">最新</span>
        <!-- <span class="category-filter-condition-item"

        :class="{'category-filter-condition-select': condition.priceSectionSort==2}">销量</span>-->
        <span v-show="false" class="category-filter-condition-item" @click="setOrderRule(2)" :class="{
          'category-filter-condition-select': condition.priceSectionSort == 2,
        }">毛利</span>
        <span v-show="false" class="category-filter-condition-item2 s1" :class="{ s2: condition.priceSectionSort == 3 }"
          @click="calcPrice">结算价</span>
        <span class="category-filter-condition-check" @click="hideGoods"
          :class="{ ischecked: condition.hideGoods }">隐藏已上架产品</span>
        <span class="category-filter-condition-check" @click="isSelf" style="width: 160px"
          :class="{ ischecked: condition.isSelf }">仅展示自产自销的商品</span>
        <span class="category-filter-condition-page">
          <span>{{ condition.pageNum }}</span>/
          <span>{{ pageCount }}</span>
          <span class="category-filter-condition-prev category-filter-page-default" @click="prev"></span>
          <span class="category-filter-condition-next category-filter-page-default" @click="next"></span>
        </span>

        <el-button class="float-right" style="height: 34px; line-height: 10px" @click="pushAll">批量加入货架</el-button>
        <el-tooltip class="item float-right" effect="dark" content="将本页所有商品添加报价至报价篮子，前往报价篮子可以批量导出商品报价" placement="top"
          popper-class="custom-width">
          <el-button style="
              background-color: #ffa726;
              border-color: #ffa726;
              height: 34px;
              line-height: 10px;
              margin-right: 10px;
              font-size: 14px;
            " type="danger" size="small" @click="getPriceAll">批量获取报价</el-button>
        </el-tooltip>
      </div>
      <div class="category-goods-wrap" v-show="hasGoods">
        <ul class="category-goods-list">
          <li class="category-goods-item" v-for="(item, index) in goodsList">
            <div class="category-goods-image" @mouseenter="showMask(index)" @mouseleave="hideMask(index)">
              <router-link tag="a" target="_blank" :to="{ name: 'Detail', query: { goodsId: item.goodsId } }">
                <img :src="imgAddress + item.goodsImage" @error="error(1)" />
                <div class="category-cover-image" :class="{ a: item.isBill == 1 }"></div>
                <div class="category-hover-product" :class="{ 'display-none': maskShow[index].isShow }">
                  <table border="0" cellspacing="0" cellpadding="0">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>
                          <span v-if="item.isBill == 0">
                            不带票结算价
                            <span v-if="item.supplyChannel == 1">(+运费)</span>
                          </span>
                          <span v-else>
                            带票结算价
                            <span v-if="item.supplyChannel == 1">(+运费)</span>
                          </span>
                        </th>
                        <th>库存</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(value, index) in item.products" v-if="index < 7">
                        <td class="category-table-SKU">
                          <div>{{ value.specName }}</div>
                        </td>
                        <td>
                          <span v-if="item.isBill == 0">
                            {{ value.settlementPrice / 100 }}
                            <span class="freight-price" v-if="item.supplyChannel == 1">(+{{ value.freight / 100
                              }})</span>
                          </span>
                          <span v-else>
                            {{ value.settlementPrice / 100 }}
                            <span class="freight-price" v-if="item.supplyChannel == 1">(+{{ value.freight / 100
                              }})</span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isBill == 0">{{
                            value.inventoryNum
                            }}</span>
                          <span v-else>{{ value.inventoryNum }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </router-link>
            </div>

            <div class="category-goods-info">
              <el-tooltip class="item" effect="dark" v-bind:content="item.goodsName" placement="top">
                <div class="category-goods-title2">{{ item.goodsName }}</div>
              </el-tooltip>
              <!-- <div class="category-goods-title2">{{item.goodsName}}</div> -->
              <div class="category-goods-type">
                <div v-if="item.supplyChannel == 2 || item.supplyChannel == 3">
                  社群集采
                </div>
                <div v-if="item.supplyChannel == 1">一件代发</div>
                <div style="
                    background-color: rgb(231, 249, 235);
                    color: rgb(88, 191, 106);
                  " v-if="item.isSelf == 1">
                  自产自销
                </div>
              </div>
              <div class="category-goods-price2">
                <div>
                  结算价
                  <span>
                    ¥
                    <span style="font-size: 18px">{{
                      item.originSettlementPrice / 100
                      }}</span>
                  </span>
                </div>
                <div>
                  毛利率 ¥
                  {{
                    (
                      ((item.salePrice - item.settlementPrice) /
                        item.salePrice) *
                      100
                    ).toFixed(2) + "%"
                  }}
                </div>
              </div>
              <div class="category-goods-price3">
                <div>建议零售价 ¥ {{ item.salePrice / 100 }}</div>
                <div>
                  毛利 ¥
                  <span style="color: #ff6015">{{
                    (item.salePrice - item.settlementPrice).toFixed(2) / 100
                    }}</span>
                </div>
              </div>
              <!-- <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">{{item.goodsName}}</div>
                <div
                  class="category-goods-title channel-dianshang"
                  v-if="item.channel == 1"
                >{{item.goodsName}}</div>
                <div
                  class="category-goods-title channel-mendian"
                  v-else-if="item.channel == 2"
                >{{item.goodsName}}</div>
                <div class="category-goods-title channel-haitao" v-else>{{item.goodsName}}</div>
              </el-tooltip>-->
            </div>
            <div v-if="globalIsBill == 0">
              <div class="category-goods-add-default yishangjia" v-if="noInventoryNum[index].haskc == 0">
                暂无库存
              </div>
              <template v-else>
                <el-row>
                  <el-col :span="12">
                    <div v-if="item.shelves == 0" class="category-goods-add-default"
                      @click="addGoodsAll(index, item.goodsId)">
                      加入货架
                    </div>
                    <div v-else class="category-goods-add-default yishangjia">
                      已加入货架
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-tooltip v-if="true || item.exitReport == 0 || item.exitReport == null" class="item"
                      effect="dark" content="添加商品报价至报价篮子，可以批量导出商品报价" placement="top">
                      <div @click="getPrice(index, item.goodsId)" class="get-price">
                        获取报价
                      </div>
                    </el-tooltip>
                    <!-- <el-tooltip
                      v-if="item.exitReport == 1"
                      class="item"
                      effect="dark"
                      content="该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！"
                      placement="top"
                    >
                      <div class="get-price yet">已添加报价</div>
                    </el-tooltip> -->
                  </el-col>
                </el-row>
              </template>
            </div>
            <div v-else>
              <div class="category-goods-add-default yishangjia" v-if="noTaxInventoryNum[index].haskc == 0">
                暂无库存
              </div>
              <template v-else>
                <el-row>
                  <el-col :span="12">
                    <div v-if="item.shelves == 0" class="category-goods-add-default"
                      @click="addGoodsAll(index, item.goodsId)">
                      加入货架
                    </div>
                    <div v-else class="category-goods-add-default yishangjia">
                      已加入货架
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-tooltip v-if="true || item.exitReport == 0 || item.exitReport == null" class="item"
                      effect="dark" content="添加商品报价至报价篮子，可以批量导出商品报价" placement="top">
                      <div @click="getPrice(index, item.goodsId)" class="get-price">
                        获取报价
                      </div>
                    </el-tooltip>
                    <!-- <el-tooltip
                      v-if="item.exitReport == 1"
                      class="item"
                      effect="dark"
                      content="该商品已添加至“报价篮子”，可以前往“报价篮子”导出报价！"
                      placement="top"
                    >
                      <div class="get-price yet">已添加报价</div>
                    </el-tooltip> -->
                  </el-col>
                </el-row>
              </template>
            </div>
          </li>
        </ul>
        <div class="block">
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
            :current-page.sync="condition.pageNum" :total="goodsListCount" :page-size="60"></el-pagination>
        </div>
      </div>
      <div class="category-goods-wrap-no" v-show="!hasGoods">
        <div class="category-goods-wrap-tip">没有找到相关商品...</div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <div style="text-align: center">
        成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="category-goods-add-default" style="width: 200px; margin: 0 auto" @click="dialogVisible = false">
          我知道了
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "../store/index.js";
import {
  addNewShelves,
  imgAddress,
  selectGoodsForEs,
  addGoodsAppReport,
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      upTime: null, //上架时间

      condition: {
        upStartTime: null,
        upEndTime: null,
        keyWord: null,
        selectType: 1,
        categoryOne: null,
        categoryTwo: null,
        categoryThree: null,
        orderRule: null,
        brandIds: [],
        hideGoods: 0,
        isSelf: 0,
        pageNum: 1,
        pageSize: 60,
        commissionSectionMax: null,
        commissionSectionMin: null,
        priceSectionMax: null,
        priceSectionMin: null,
        profitSectionMax: null,
        profitSectionMin: null,
        salePriceMax: null,
        salePriceMin: null,
        priceSectionSort: 1, //结算价排序 0:正序,1逆序.
        userId: store.state.userId,
        taxData: store.state.isBill,
        position: (this.$route.query.position || 1),
      },
      commissionSectionMax: null,
      commissionSectionMin: null,
      priceSectionMax: null,
      priceSectionMin: null,
      profitSectionMax: null,
      profitSectionMin: null,
      salePriceMax: null,
      salePriceMin: null,
      goodsList: {},
      categoryOneData: [],
      categoryTwoData: {},
      categoryThreeData: {},
      brandData: {},
      filter: {
        time: {
          id: 1,
          isSelect: true,
        },
        money: {
          id: 2,
          isSelect: false,
        },
        price: {
          id: 3,
          isSelect: false,
        },
        profit: {
          id: 4,
          isSelect: false,
        },
      },
      breadcrum: [],
      more: {
        one: false,
        two: false,
        three: false,
        four: false,
      },
      conditionShow: {
        one: false,
        two: true,
        three: true,
        four: true,
      },
      maskShow: {},
      goodsListCount: 0,
      pageCount: "",
      brandName: "",
      deep: [
        {
          deepOne: "",
        },
        {
          deepTwo: "",
        },
        {
          deepThree: "",
        },
      ],
      imgAddress: imgAddress,
      hasGoods: true,
      noInventoryNum: {},
      noTaxinventoryNum: {},
      colorMain: store.state.colorMain,
      textDa: false,
      dialogVisible: false,
    };
  },
  created() {
    this.condition.categoryOne = this.$route.query.levelOne;
    this.condition.categoryTwo = this.$route.query.levelTwo;
    this.condition.categoryThree = this.$route.query.levelThree;
    this.condition.categoryOneName = this.$route.query.levelOneText;
    this.condition.categoryTwoName = this.$route.query.levelTwoText;
    this.condition.categoryThreeName = this.$route.query.levelThreeText;

    this.condition.keyWord = this.$route.query.keyWord;
    this.condition.selectType = this.$route.query.selectType;

    var arr = [];
    if (this.$route.query.brandId != "") {
      arr.push(this.$route.query.brandId);
    }
    this.condition.brandIds = arr;
  },
  computed: {
    globalIsBill() {
      if (this.$store.state.isBill == 1) {
        return 0;
      } else {
        return 1;
      }
    },
    isbill() {
      return this.$store.state.isBill;
    },
  },
  watch: {
    upTime(newvaule, oldvalue) {
      if (newvaule) {
        this.condition.upStartTime = moment(newvaule[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.condition.upEndTime = moment(newvaule[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        this.condition.upStartTime = null;
        this.condition.upEndTime = null;
      }

      console.log(newvaule);
    },

    $route(to, from) {
      console.log("路由改变");
      location.reload(true);
      // console.log(to);
    },
    // 如果路由有变化，会再次执行该方法
    //$route: "routeChange",
    globalIsBill(val) {
      var that = this;
      that.inventoryNum();
      console.log("this.isBill=" + val);
    },
    isbill() {
      this.textDa = true;
      if (this.$store.state.isBill === 0 && this.textDa) {
        this.textDa = false;
        this.setTaxData(0);
      } else if (this.$store.state.isBill === 1 && this.textDa) {
        this.textDa = false;
        this.setTaxData(1);
      } else if (this.$store.state.isBill === 2 && this.textDa) {
        this.textDa = false;
        this.setTaxData(2);
      }
    },
  },
  mounted() {
    this.init();
  },
  updated() { },
  methods: {
    handleClose() { },
    getPriceAll() {
      let _this = this;

      var goodsIdList = [];
      for (var i in this.goodsList) {
        // if (this.goodsList[i].shelves == 0) {
        var products = this.goodsList[i].products;
        for (var j in products) {
          goodsIdList.push(this.goodsList[i].goodsId);
        }
        // }
      }
      var data = {
        goodsIdList: goodsIdList,
        appId: this.$store.state.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        if (res.code == 10000) {
          _this.dialogVisible = true;
          _this.init();
        }
      });
    },
    getPrice(index, goodsId) {
      let _this = this;
      var data = {
        goodsIdList: [goodsId],
        appId: this.$store.state.appId,
      };
      fetch(addGoodsAppReport, data).then((res) => {
        // _this.dialogVisible = true;
        if (res.code == 10000) {
          toast('已加入报价篮子', 1, false);
          _this.init();
        }
      });
    },
    calcPrice() {
      let params = this.condition;

      if (this.condition.priceSectionSort == 3) {
        this.condition.priceSectionSort = 4;
      } else {
        this.condition.priceSectionSort = 3;
      }
      this.init();
    },
    ...mapActions({ setGoodsCount: "setGoodsCount" }),
    error(num) {
      imageError(num, event);
    },
    onCancel() {
      this.commissionSectionMax = null;
      this.commissionSectionMin = null;
      this.priceSectionMax = null;
      this.priceSectionMin = null;
      this.profitSectionMax = null;
      this.profitSectionMin = null;
      this.salePriceMax = null;
      this.salePriceMin = null;

      this.condition.commissionSectionMax = null;
      this.condition.commissionSectionMin = null;
      this.condition.priceSectionMax = null;
      this.condition.priceSectionMin = null;
      this.condition.profitSectionMax = null;
      this.condition.profitSectionMin = null;
      this.condition.salePriceMax = null;
      this.condition.salePriceMin = null;
      this.condition.upStartTime = null;
      this.condition.upEndTime = null;
      this.upTime = null;

      this.init();
    },
    routeChange() {
      this.condition.categoryOne = this.$route.query.levelOne;
      this.condition.categoryTwo = this.$route.query.levelTwo;
      this.condition.categoryThree = this.$route.query.levelThree;
      this.condition.keyWord = this.$route.query.keyWord;
      this.condition.selectType = this.$route.query.selectType;
      var arr = [];
      if (this.$route.query.brandId != "") {
        arr.push(this.$route.query.brandId);
      }
      if (this.condition.keyWord) {
        this.breadcrum = [];
        this.conditionShow.one = true;
        this.conditionShow.two = true;
        this.conditionShow.three = true;
        this.conditionShow.four = true;
      }
      this.condition.brandIds = arr;
      this.init();
    },
    handleCurrentChange(val) {
      this.condition.pageNum = val;
      this.init();
    },
    init() {
      var that = this;
      var data = this.condition;
      // var url = getSearchCondition;
      var brand = this.condition.brandIds[0];
      console.log();
      var params2 = [];
      params2["appId"] = this.condition["appId"];
      params2["categoryOne"] = this.condition["categoryOne"];
      params2["categoryThree"] = this.condition["categoryThree"];
      params2["categoryTwo"] = this.condition["categoryTwo"];
      params2["userId"] = this.condition["userId"];

      // fetch(url, { ...params2 }).then((res) => {
      //   var categoryOne = this.condition.categoryOne;
      //   var categoryTwo = this.condition.categoryTwo;
      //   var categoryThree = this.condition.categoryThree;

      //   // this.categoryOneData = this.initCateValue(
      //   //   0,
      //   //   categoryOne,
      //   //   res.data.categoryOne
      //   // );
      //   if (res.data.categoryTwo) {
      //     this.categoryTwoData = this.initCateValue(
      //       2,
      //       categoryTwo,
      //       res.data.categoryTwo
      //     );
      //   }
      //   if (res.data.categoryThree) {
      //     this.categoryThreeData = this.initCateValue(
      //       3,
      //       categoryThree,
      //       res.data.categoryThree
      //     );
      //   }

      //   console.log("abc", this.categoryTwoData);

      //   this.brandData = this.initBrandValue(brand, res.data.brand);

      //   var arr1 = [];

      //   var categoryOneId = this.condition.categoryOne;
      //   var categoryTwoId = this.condition.categoryTwo;
      //   var categoryThreeId = this.condition.categoryThree;
      //   var categoryOneName = this.condition.categoryOneName;
      //   var categoryTwoName = this.condition.categoryTwoName;
      //   var categoryThreeName = this.condition.categoryThreeName;
      //   //品牌
      //   var name = this.brandName;
      //   if (
      //     categoryOneId == "" &&
      //     categoryTwoId == "" &&
      //     categoryThreeId == "" &&
      //     name == ""
      //   ) {
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = true;
      //     this.conditionShow.two = true;
      //     this.conditionShow.three = true;
      //     this.conditionShow.four = true;
      //   } else if (
      //     categoryOneId != "" &&
      //     categoryTwoId == "" &&
      //     categoryThreeId == "" &&
      //     name == ""
      //   ) {
      //     var opt = {
      //       name: categoryOneName,
      //       deep: 1,
      //     };
      //     arr1.push(opt);
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = false;
      //     this.conditionShow.two = false;
      //     this.conditionShow.three = true;
      //     this.conditionShow.four = true;
      //   } else if (
      //     categoryOneId != "" &&
      //     categoryTwoId != "" &&
      //     categoryThreeId == "" &&
      //     name == ""
      //   ) {
      //     var opt = {
      //       name: categoryOneName,
      //       deep: 1,
      //     };
      //     var obj = {
      //       name: categoryTwoName,
      //       deep: 2,
      //     };
      //     arr1.push(opt);
      //     arr1.push(obj);
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = true;
      //     this.conditionShow.two = true;
      //     this.conditionShow.three = false;
      //     this.conditionShow.four = false;
      //   } else if (
      //     categoryOneId != "" &&
      //     categoryTwoId != "" &&
      //     categoryThreeId != "" &&
      //     name == ""
      //   ) {
      //     var opt = {
      //       name: categoryOneName,
      //       deep: 1,
      //     };
      //     var obj = {
      //       name: categoryTwoName,
      //       deep: 2,
      //     };
      //     var o = {
      //       name: categoryThreeName,
      //       deep: 3,
      //     };
      //     arr1.push(opt);
      //     arr1.push(obj);
      //     arr1.push(o);
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = true;
      //     this.conditionShow.two = true;
      //     this.conditionShow.three = false;
      //     this.conditionShow.four = false;
      //   } else if (
      //     categoryOneId != "" &&
      //     categoryTwoId != "" &&
      //     categoryThreeId == "" &&
      //     name != ""
      //   ) {
      //     var opt = {
      //       name: categoryOneName,
      //       deep: 1,
      //     };
      //     var obj = {
      //       name: categoryTwoName,
      //       deep: 2,
      //     };
      //     /*var o = {
      //     			name: ,
      //     	 				deep: 3
      //     		}*/
      //     arr1.push(opt);
      //     arr1.push(obj);
      //     // arr1.push(o);
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = true;
      //     this.conditionShow.two = true;
      //     this.conditionShow.three = false;
      //     this.conditionShow.four = false;
      //   } else if (
      //     categoryOneId != "" &&
      //     categoryTwoId != "" &&
      //     categoryThreeId != "" &&
      //     name != ""
      //   ) {
      //     var opt = {
      //       name: categoryOneName,
      //       deep: 1,
      //     };
      //     var obj = {
      //       name: categoryTwoName,
      //       deep: 2,
      //     };
      //     var o = {
      //       name: categoryThreeName,
      //       deep: 3,
      //     };
      //     arr1.push(opt);
      //     arr1.push(obj);
      //     arr1.push(o);
      //     this.breadcrum = arr1;
      //     this.conditionShow.one = true;
      //     this.conditionShow.two = true;
      //     this.conditionShow.three = false;
      //     this.conditionShow.four = false;
      //   }
      // });

      //  let priceSectionSort = 1; //结算价排序
      ///let selectType = 1; //1,商品,2品牌
      let params1 = [];
      params1["brandIds"] = this.condition["brandIds"];
      params1["categoryOne"] = this.condition["categoryOne"];
      params1["categoryThree"] = this.condition["categoryThree"];
      params1["categoryTwo"] = this.condition["categoryTwo"];
      params1["commissionSectionMax"] = this.condition["commissionSectionMax"];
      params1["commissionSectionMin"] = this.condition["commissionSectionMin"];
      params1["hideGoods"] = this.condition["hideGoods"];
      params1["isSelf"] = this.condition["isSelf"] == 0 ? null : 1;
      params1["keyWord"] = this.condition["keyWord"];
      params1["priceSectionMax"] = this.condition["priceSectionMax"];
      params1["keyWord"] = this.condition["keyWord"];
      params1["priceSectionMax"] = this.condition["priceSectionMax"];
      params1["priceSectionMin"] = this.condition["priceSectionMin"];
      params1["sort"] = this.condition["priceSectionSort"];
      params1["profitSectionMax"] = this.condition["profitSectionMax"];
      params1["profitSectionMin"] = this.condition["profitSectionMin"];
      params1["salePriceMax"] = this.condition["salePriceMax"];
      params1["salePriceMin"] = this.condition["salePriceMin"];
      params1["userId"] = this.condition["userId"];
      params1["pageNum"] = this.condition["pageNum"];
      params1["pageSize"] = this.condition["pageSize"];
      params1["startTime"] = this.condition["upStartTime"];
      params1["endTime"] = this.condition["upEndTime"];
      params1["position"] = this.condition["position"];


      console.log(this.condition);
      if (this.condition["selectType"]) {
        params1["selectType"] = this.condition["selectType"];
      } else {
        params1["selectType"] = 1;
      }

      //获取商品
      fetch(selectGoodsForEs, {
        ...params1,
        appId: this.$store.state.appId,
      }).then((res) => {
        this.goodsList = res.data.result;

        if (this.goodsList.length == 0) {
          this.hasGoods = false;
        } else {
          this.hasGoods = true;
        }
        var arr = [];
        for (var i = 0; i < this.goodsList.length; i++) {
          var opt = {
            isShow: true,
          };
          arr.push(opt);
        }
        this.maskShow = arr;
        this.goodsListCount = res.data.count;
        this.pageInit();
        that.inventoryNum();
      });
    },
    inventoryNum() {
      var arr2 = [];
      if (this.globalIsBill == 0) {
        for (var i = 0; i < this.goodsList.length; i++) {
          var item = this.goodsList[i];
          var obj = {
            haskc: 0,
          };
          for (var j = 0; j < item.products.length; j++) {
            if (item.products[j].inventoryNum != 0) {
              obj.haskc = 1;
            }
          }
          arr2.push(obj);
        }
        this.noInventoryNum = arr2;
      } else {
        for (var i = 0; i < this.goodsList.length; i++) {
          var item = this.goodsList[i];
          var obj = {
            haskc: 0,
          };
          for (var j = 0; j < item.products.length; j++) {
            if (item.products[j].taxInventoryNum != 0) {
              obj.haskc = 1;
            }
          }
          arr2.push(obj);
        }
        this.noTaxInventoryNum = arr2;
      }
    },
    initCateValue(index, value, arr) {
      var list = [];
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i].categoryId) {
          var opt = {
            id: arr[i].categoryId,
            name: arr[i].name,
            parentId: arr[i].parentId,
            deep: arr[i].deep,
            isSelect: true,
          };
        } else {
          var opt = {
            id: arr[i].categoryId,
            name: arr[i].name,
            parentId: arr[i].parentId,
            deep: index,
            isSelect: false,
          };
        }
        list.push(opt);
      }
      return list;
    },
    initBrandValue: function (value, arr) {
      var list = [];
      if (arr) {
        for (var i = 0; i < arr.length; i++) {
          if (value == arr[i].brandId) {
            var opt = {
              id: arr[i].brandId,
              name: arr[i].brandName,
              logoPath: arr[i].logoPath,
              isSelect: true,
            };
            this.brandName = arr[i].brandName;
          } else {
            var opt = {
              id: arr[i].brandId,
              name: arr[i].brandName,
              logoPath: arr[i].logoPath,
              isSelect: false,
            };
          }
          list.push(opt);
        }
      }

      return list;
    },
    setBracdSelect: function (id) {
      var conditionBrand = this.condition.brandIds[0];
      var brandData = this.brandData;
      var name = "";

      for (var i = 0; i < brandData.length; i++) {
        if (id == brandData[i].id) {
          name = brandData[i].name;
          break;
        }
      }
      if (id == conditionBrand) {
        this.condition.brandIds = [];
        this.brandName = "";
      } else {
        var brand = [id];
        this.brandName = name;
        this.condition.brandIds = brand;
      }
      this.init();
    },
    setOrderRule: function (id) {
      // var filter = this.filter;
      // for (var i in filter) {
      //   if (filter[i].id == id) {
      //     filter[i].isSelect = true;
      //     this.condition.orderRule = id;
      //   } else {
      //     filter[i].isSelect = false;
      //   }
      // }

      this.condition.priceSectionSort = id;
      this.init();
    },
    hideGoods: function () {
      var hideGoods = this.condition.hideGoods;
      if (hideGoods == 0) {
        this.condition.hideGoods = 1;
      } else {
        this.condition.hideGoods = 0;
      }
      this.condition.pageNum = 1;
      this.init();
    },
    isSelf: function () {
      this.condition.isSelf = this.condition.isSelf == 1 ? 0 : 1;
      this.condition.pageNum = 1;
      this.init();
    },
    setcate: function (id, deep, title) {
      console.log("deep2" + deep);
      if (deep == 1) {
        console.log("deep" + deep);
        this.condition.categoryOne = id;
        this.condition.categoryTwo = "";
        this.condition.categoryThree = "";
        this.conditionShow.one = true;
        this.conditionShow.two = false;
        this.conditionShow.three = true;
        this.conditionShow.four = true;
        this.condition.categoryOneName = title;
      } else if (deep == 2) {
        this.condition.categoryTwo = id;
        this.condition.categoryThree = "";
        this.conditionShow.one = true;
        this.conditionShow.two = true;
        this.conditionShow.three = false;
        this.conditionShow.four = false;
        this.condition.categoryTwoName = title;
      } else if (deep == 3) {
        this.condition.categoryThree = id;
        this.conditionShow.one = true;
        this.conditionShow.two = true;
        this.conditionShow.three = false;
        this.conditionShow.four = false;

        this.condition.categoryThreeName = title;
      }

      this.init();
    },
    closeBread: function (deep) {
      if (deep == 1) {
        this.condition.categoryOne = "";
        this.condition.categoryTwo = "";
        this.condition.categoryThree = "";
        this.conditionShow.one = false;
        this.conditionShow.two = true;
        this.conditionShow.three = true;
        this.conditionShow.four = true;
        this.brandName = "";
        this.condition.brandIds = [];

        this.categoryOneData = [];
        this.conditionShow.one = true;

        if (this.breadcrum.length >= 3) {
          this.breadcrum.pop();
          this.breadcrum.pop();
        } else if (this.breadcrum.length >= 2) {
          this.breadcrum.pop();
        }
        this.breadcrum.pop();
      } else if (deep == 2) {
        this.condition.categoryTwo = "";
        this.condition.categoryThree = "";
        this.conditionShow.one = false;
        this.conditionShow.two = false;
        this.conditionShow.three = true;
        this.conditionShow.four = true;
        this.brandName = "";
        this.condition.brandIds = [];
        let obj = {
          name: this.condition.categoryOneName,
          isSelect: true,
        };
        console.log("123", obj);
        this.categoryOneData.push(obj);
        if (this.breadcrum.length >= 3) {
          this.breadcrum.pop();
        }
        this.breadcrum.pop();
      } else if (deep == 3) {
        this.condition.categoryThree = "";
        this.brandName = "";
        this.condition.brandIds = [];
        this.breadcrum.pop();
        this.conditionShow.one = true;
        this.conditionShow.two = true;
        this.conditionShow.three = false;
        this.conditionShow.four = false;
      } else if (deep == 0) {
        this.brandName = "";
        this.condition.brandIds = [];
        this.breadcrum.pop();
        this.condition.categoryOne = "";
        this.condition.categoryTwo = "";
        this.condition.categoryThree = "";
        this.conditionShow.one = false;
        this.conditionShow.two = true;
        this.conditionShow.three = true;
        this.conditionShow.four = true;
      }
      this.init();
    },
    open: function (id) {
      if (id == 1) {
        this.more.one = !this.more.one;
      } else if (id == 2) {
        this.more.two = !this.more.two;
      } else if (id == 3) {
        this.more.three = !this.more.three;
      } else {
        this.more.four = !this.more.four;
      }
    },
    showMask: function (index) {
      this.maskShow[index].isShow = false;
    },
    hideMask: function (index) {
      this.maskShow[index].isShow = true;
    },
    addGoodsAll: function (index, goodsId) {
      var List = [];
      var tableInfo = this.goodsList[index].products;
      console.log("cailu", tableInfo);
      for (var i in tableInfo) {
        var goodsItem = {};
        goodsItem.productId = tableInfo[i].productId;
        goodsItem.goodsId = goodsId;
        goodsItem.hasTax = this.goodsList[index].isBill;
        //社群集采2 一件代发1
        if (
          this.goodsList[index].supplyChannel == 2 ||
          this.goodsList[index].supplyChannel == 3
        ) {
          goodsItem.appType = 2;
        } else {
          goodsItem.appType = 1;
        }
        goodsItem.activityDetailId = tableInfo[i].activityDetailId;
        List.push(goodsItem);
      }
      var data = {
        goodsList: List,
        userId: this.condition.userId,
        bodyId: this.$store.state.bodyId,
        appId: this.$store.state.appId,
      };
      var url = addNewShelves;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          var str = "上架成功";
          toast(str, 1, false);
          this.goodsList[index].shelves = 1;
          this.setGoodsCount();
        } else {
          var str = "上架失败";
          toast(str, 2, false);
        }
      });
    },
    pushAll() {
      var List = [];
      for (var i in this.goodsList) {
        if (this.goodsList[i].shelves == 0) {
          var products = this.goodsList[i].products;
          for (var j in products) {
            var goodsItem = {};
            goodsItem.productId = products[j].productId;
            goodsItem.hasTax = this.goodsList[i].isBill;
            //社群集采2 一件代发1
            if (
              this.goodsList[i].supplyChannel == 2 ||
              this.goodsList[i].supplyChannel == 3
            ) {
              goodsItem.appType = 2;
            } else {
              goodsItem.appType = 1;
            }
            goodsItem.goodsId = this.goodsList[i].goodsId;
            goodsItem.activityDetailId = this.goodsList[i].products[
              j
            ].activityDetailId;
            List.push(goodsItem);
          }
        }
      }
      var data = {
        goodsList: List,
        userId: this.condition.userId,
        bodyId: this.$store.state.bodyId,
        appId: this.$store.state.appId,
      };
      var url = addNewShelves;
      fetch(url, data).then((res) => {
        if (res.code == 10000) {
          var str = "上架成功";
          toast(str, 1, false);
          this.init();
          this.setGoodsCount();
        } else {
          var str = "上架失败";
          toast(str, 2, false);
        }
      });
    },
    pageInit() {
      var pageCount = Math.ceil(this.goodsListCount / 30);
      this.pageCount = pageCount;
    },
    prev() {
      if (this.condition.pageNum > 1) {
        this.condition.pageNum = this.condition.pageNum - 1;
      }
    },
    next() {
      if (this.condition.pageNum < this.pageCount) {
        this.condition.pageNum = this.condition.pageNum + 1;
      }
    },
    sectionInit() {
      if (this.commissionSectionMax && this.commissionSectionMin) {
        this.condition.commissionSectionMax = this.commissionSectionMax * 100;
        this.condition.commissionSectionMin = this.commissionSectionMin * 100;
      }

      if (this.priceSectionMax && this.priceSectionMin) {
        this.condition.priceSectionMax = this.priceSectionMax * 100;
        this.condition.priceSectionMin = this.priceSectionMin * 100;
      }

      if (this.profitSectionMax && this.profitSectionMin) {
        this.condition.profitSectionMax = this.profitSectionMax.split("%")[0];
        this.condition.profitSectionMin = this.profitSectionMin.split("%")[0];
      }

      if (this.salePriceMax && this.salePriceMin) {
        this.condition.salePriceMax = this.salePriceMax * 100;
        this.condition.salePriceMin = this.salePriceMin * 100;
      }

      this.init();
    },
    setTaxData: function (taxData) {
      this.condition.taxData = taxData;
      console.log(this.condition.taxData);
      this.init();
    },
  },
};
</script>
<style>
.custom-width {
  width: 400px;
}
</style>
<style scoped>
.category-cover-image.a {
  background: url(../assets/img/hanshui.png) no-repeat top right/60px 60px;
}

.category-cover-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: url(../assets/img/buhanshui.png) no-repeat top right/60px 60px;
}

.category-filter-condition-item2 {
  display: inline-block;
  height: 33px;
  width: 90px;
  font-size: 12px;
  line-height: 33px;
  color: #494949;
  background-image: url(../assets/img/jiage_weixuan.png);
  background-repeat: no-repeat;
  background-size: 8px;
  background-position: 68px center;
  border-right: 1px solid #f1f1f1;
  text-indent: 30px;
  cursor: pointer;
}

.category-filter-condition-item2.s1 {
  background-image: url(../assets/img/jiage_sheng.png);
}

.category-filter-condition-item2.s2 {
  background-image: url(../assets/img/jiage_jiang.png);
}

.category-goods-price2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.category-goods-price2>div:nth-child(1) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}

.category-goods-price2>div:nth-child(1)>span {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(254, 169, 35, 1);
  line-height: 17px;
}

.category-goods-price2>div:nth-child(2) {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}

.category-goods-price3 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-top: 5px;
}

.category-goods-type {
  display: flex;
  flex-direction: row;
  margin: 6px 0;
}

.category-goods-type>div {
  width: 60px;
  height: 22px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}

.category-goods-title2 {
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  height: 38px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.get-price {
  margin-left: 10px;
  margin-top: 10px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fea923;
  color: #fea923;
  cursor: pointer;
  background-color: #fff5ea;
}

.get-price.yet {
  background-color: #c0c0c0;
  color: #fff;
  border: 1px solid #c0c0c0;
}
</style>



// WEBPACK FOOTER //
// Category.vue?05be80e8